import { render } from "./FormSelect.vue?vue&type=template&id=b4ae27b2"
import script from "./FormSelect.vue?vue&type=script&lang=ts"
export * from "./FormSelect.vue?vue&type=script&lang=ts"

import "./FormSelect.vue?vue&type=style&index=0&id=b4ae27b2&lang=stylus"
script.render = render

export default script